import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { PartnerProgramService } from '@/services/partner-program.service';
import { AxiosError } from 'axios';
import { AxiosErrorResponse } from '@/@types/Errors';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useApplyPartnerInvitation = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation('invitationPartnerLink');

  const { mutate, isPending: isConfiguring } = useMutation({
    mutationFn: (productId: string) =>
      PartnerProgramService.applyPartnerProgram(productId),
    onSuccess: async () => {
      localStorage.removeItem('redirectAfterEmailVerification');
      navigate('/invitation-partner-confirm');
    },
    onError: (error: AxiosError<AxiosErrorResponse>) => {
      toast({
        variant: 'error',
        description: error?.response?.data?.message || t('error'),
      });
    },
  });

  return {
    applyPartnerInvitation: mutate,
    isConfiguring,
  };
};
